/**
 * StingBase
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { InlineObject } from '../model/models';
import { InlineObject1 } from '../model/models';
import { OrderBranchResource } from '../model/models';
import { OrderBrokerResource } from '../model/models';
import { OrderDetailResource } from '../model/models';
import { OrderList200Response } from '../model/models';
import { OrderListRequest } from '../model/models';
import { OrderLocalityResource } from '../model/models';
import { OrderPropertyResource } from '../model/models';


import { Configuration } from '../configuration';
import { OrderInterestResource } from '../model/orderInterestResource';



export interface OrderServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Order branches
     *
     */
    orderBranches(extraHttpRequestParams?: any): Observable<Array<OrderBranchResource>>;

    /**
     * Order detail
     *
     * @param orderId
     */
    orderDetail(orderId: number, extraHttpRequestParams?: any): Observable<OrderDetailResource>;

    /**
     * Order interests
     *
     * @param orderId
     * @param fulltext
     * @param page
     * @param perPage
     */
    orderInterests(orderId: number, fulltext?: string, page?: number, perPage?: number, extraHttpRequestParams?: any): Observable<Array<OrderInterestResource>>;

    /**
     * Order list
     *
     * @param own
     * @param orderType
     * @param lat
     * @param lon
     * @param limit
     * @param offset
     * @param fulltext
     * @param orderListRequest
     */
    orderList(own?: boolean, orderType?: string, lat?: string, lon?: string, limit?: number, offset?: number, fulltext?: string, orderListRequest?: OrderListRequest, extraHttpRequestParams?: any): Observable<OrderList200Response>;

    /**
     * Order properties
     *
     */
    orderProperties(extraHttpRequestParams?: any): Observable<Array<OrderPropertyResource>>;

    /**
     * Order real estate agents
     *
     * @param departmentId
     */
    orderRealEstateAgents(departmentId?: number, extraHttpRequestParams?: any): Observable<Array<OrderBrokerResource>>;

    /**
     * Order search locality
     *
     * @param query
     */
    orderSearchLocality(query?: string, extraHttpRequestParams?: any): Observable<Array<OrderLocalityResource>>;

}
